export const ON_FIRMWARE_INFO_RECEIVED = 'ON_FIRMWARE_INFO_RECEIVED'
export const ON_BUILD_INFO_RECEIVED = 'ON_BUILD_INFO_RECEIVED'
export const ON_TERMINAL_INFO_RECEIVED = 'ON_TERMINAL_INFO_RECEIVED'
export const ERROR_TRANSACTION = 'ERROR_TRANSACTION'
export const CLEAR_TRANSACTION_ERROR = 'CLEAR_TRANSACTION_ERROR'
export const ON_PERIPHERAL_BUSY_STATE_CHANGE = 'ON_PERIPHERAL_BUSY_STATE_CHANGE'
export const ON_SAF_IS_UPLOADING = 'ON_SAF_IS_UPLOADING'
export const ON_SAF_UPLOAD_COMPLETE = 'ON_SAF_UPLOAD_COMPLETE'
export const ON_SAF_FULL_RESPONSE_RECEIVED = 'ON_SAF_FULL_RESPONSE_RECEIVED'
export const ON_RESET_SAF_FULL_RESPONSE = 'ON_RESET_SAF_FULL_RESPONSE'

export const onFirmwareInfoReceived = (payload) => {
  return {
    type: ON_FIRMWARE_INFO_RECEIVED,
    payload,
  }
}

export const onBuildInfoReceived = (payload) => {
  return {
    type: ON_BUILD_INFO_RECEIVED,
    payload,
  }
}

export const onTerminalInfoReceived = (payload) => {
  return {
    type: ON_TERMINAL_INFO_RECEIVED,
    payload,
  }
}

export const onPeripheralBusyStateChange = (payload) => {
  return {
    type: ON_PERIPHERAL_BUSY_STATE_CHANGE,
    payload
  }
}

export const setSafUploadComplete = (payload) => {
  return {
    type: ON_SAF_UPLOAD_COMPLETE,
    payload
  }
}

export const onSafIsUploading = (payload) => {
  return {
    type: ON_SAF_IS_UPLOADING,
    payload
  }
}

export const setSafFullResponse = (payload) => {
  return {
    type: ON_SAF_FULL_RESPONSE_RECEIVED,
    payload
  }
}

export const resetSafFullResponse = () => {
  return {
    type: ON_RESET_SAF_FULL_RESPONSE,
  }
}
